var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-app col-12 col-xl-3 col-lg-3 col-md-4 col-sm-12 container column"},[_c('userProperties',{staticClass:"animation-top animation-delay-01",attrs:{"user":_vm.student}}),_vm._v(" "),_c('feed',{staticClass:"animation-top animation-delay-05"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae2f95a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"audio":["src"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/index.vue
// module id = 894
// module chunks = 2 7 23